import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box, Chip, ChipProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactElement } from 'react';

interface CustomChipProps extends Omit<ChipProps, 'label'> {
  textContent: string;
  active?: boolean;
}

const DEFAULT_BG = tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_enabled_lt;
const HOVER_BG = tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_hover_lt;

const ACTIVE_BG = tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_enabled;
const ACTIVE_HOVER = tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_enabled;

const DEFAULT_TEXT = tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled;
const ACTIVE_TEXT = tsoPqTheme.palette.customTextColor.color_font_ft_white;

const StyledFilterChip = styled(Chip, {
  shouldForwardProp: (prop) => !['active', 'textContent'].includes(prop as string),
})<CustomChipProps>(({ active }) => ({
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: tsoPqTheme.typography.fontsize_button_button_small,
  backgroundColor: active ? ACTIVE_BG : DEFAULT_BG,
  color: active ? ACTIVE_TEXT : DEFAULT_TEXT,
  fontStyle: 'normal',
  display: 'inline-flex',
  alignItems: 'center',
  letterSpacing: '0.007rem',

  fontWeight: '400',
  textTransform: 'none',
  borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
  padding: `${tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4} ${tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_8}`,
  height: '1.625rem',
  '&:hover': {
    backgroundColor: active ? ACTIVE_HOVER : HOVER_BG,
    cursor: 'pointer',
  },
  '& .MuiChip-label': {
    padding: 0,
  },
}));

const ChipFilterTsoPq = ({ textContent, onClick, active, ...props }: CustomChipProps): ReactElement => (
  <StyledFilterChip
    {...props}
    active={active}
    textContent={textContent}
    label={<Box>{textContent}</Box>}
    onClick={onClick}
  />
);

export default ChipFilterTsoPq;
